import React from "react";
import { withTranslationReady } from "../../../common/i18n/withTranslationReady";
import OrderApplicationSubmittedContainer from "client/components/OrderApplicationSubmitted/OrderApplicationSubmittedContainer";

const OrderApplicationSubmittedScene = () => {
  return <OrderApplicationSubmittedContainer />;
};

export default withTranslationReady(["generic"])(OrderApplicationSubmittedScene);
